module.exports = __webpack_public_path__ + "static/media/feature_security_controls.4d9b4bf0.png";